var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.875,
    y: 5.75,
    width: 17.25,
    height: 14.375,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875 9.58333C2.875 7.85928 2.875 6.99725 3.37132 6.43131C3.42888 6.36567 3.49067 6.30388 3.55631 6.24632C4.12225 5.75 4.98428 5.75 6.70833 5.75H16.2917C18.0157 5.75 18.8777 5.75 19.4437 6.24632C19.5093 6.30388 19.5711 6.36567 19.6287 6.43131C20.125 6.99725 20.125 7.85928 20.125 9.58333H2.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70801 2.875L6.70801 5.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.292 2.875L16.292 5.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.70801,
    y: 11.5,
    width: 3.83333,
    height: 1.91667,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.70801,
    y: 15.3335,
    width: 3.83333,
    height: 1.91667,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.458,
    y: 11.5,
    width: 3.83333,
    height: 1.91667,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.458,
    y: 15.3335,
    width: 3.83333,
    height: 1.91667,
    rx: 0.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/AppointmentIcon.903dec49.svg";
export { ForwardRef as ReactComponent };